export default __webpack_public_path__ + "static/media/icon-flavour.7ed9c477.svg";